import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InitialsAvatarComponent} from './initials-avatar.component';

@NgModule({
  declarations: [InitialsAvatarComponent],
  imports: [CommonModule],
  exports: [InitialsAvatarComponent]
})
export class InitialsAvatarModule {}
